import type { PanelNote } from "./types";

type Props = {
  notesOpen: boolean;
  note: PanelNote | null;
  onToggle: () => void;
};

export function KbNotesPanel(props: Props) {
  return (
    <details className="rounded-2xl border border-gray-200 bg-white dark:border-zinc-700 dark:bg-zinc-900/45" open={props.notesOpen}>
      <summary
        className="cursor-pointer list-none px-4 py-3"
        onClick={(event) => {
          event.preventDefault();
          props.onToggle();
        }}
      >
        <div className="flex items-center justify-between gap-3">
          <div>
            <div className="text-sm font-semibold text-gray-900 dark:text-zinc-100">Notes</div>
            <div className="text-xs text-gray-600 dark:text-zinc-300">Errors, save feedback, and operational notes stay here so the rest of the workspace stays quiet.</div>
          </div>
          <div className="text-xs text-gray-500 dark:text-zinc-400">{props.notesOpen ? "Hide" : "Show"}</div>
        </div>
      </summary>
      <div className="border-t border-gray-200 px-4 py-3 dark:border-zinc-700">
        {props.note ? (
          <div className={
            "rounded-xl border px-3 py-3 text-sm " +
            (props.note.tone === "error"
              ? "border-rose-200 bg-rose-50 text-rose-900 dark:border-rose-800 dark:bg-rose-950/40 dark:text-rose-100"
              : props.note.tone === "success"
                ? "border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-100"
                : "border-indigo-200 bg-indigo-50 text-indigo-900 dark:border-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-100")
          }>
            <div className="font-medium">{props.note.title}</div>
            <div className="mt-1 text-sm">{props.note.text}</div>
          </div>
        ) : (
          <div className="text-sm text-gray-500 dark:text-zinc-400">No notes yet. Feedback will appear here after searches, loads, previews, saves, and imports.</div>
        )}
      </div>
    </details>
  );
}